export const LABELS = {
  leaveComment: 'Leave a comment',
}
